
<template>

	<div class="data-picker">

		<b-form-input :value="current_date" type="text" autocomplete="off" :size="size" :readonly="readonly" v-on:change="on_input" v-mask="mask" placeholder="__.__.____" />
		<b-form-datepicker class="data-picker_datepicker" size="sm" v-model="current_date_pick" start-weekday="1" :date-format-options="date_format" v-on:input="on_pick" value-as-date button-only button-variant="light-gray" :boundary="new_modal ? 'window' : 'scrollParent'" :disabled="readonly" />

	</div>

</template>

<script>

import api from "../../api"

export default
{
	props :
	{
		value : [ Date, String ],
		new_modal : Boolean,
		readonly : { type : Boolean, default : () => false },
		size : { type : String, default : () => "md" }
	},

	data()
	{
		return {

			current_date : null,
			current_date_pick : null,
			date_format : { year: "numeric", month: "numeric", day: "numeric" },
			
			mask :
			{
				mask : "*{2}\\.*{2}\\.*{4}",
				greedy : false,
				definitions : { "*" : { validator : "[0-9]", casing : "lower" } }
			},
		}
	},

	watch :
	{
		value :
		{
			immediate : true,

			handler(value)
			{
				//if(this.current_date == null && value != null)
				if(value != null)
				{
					this.current_date = api.format_date(value)
					this.current_date_pick = value
				}
			}
		},
	},

	methods :
	{
		on_input(new_value)
		{
			const fields = new_value.split(".")

			if(fields.length == 3)
			{
				const value = new Date(fields[2] + "-" + fields[1] + "-" + fields[0])

				if(value != "Invalid Date")
				{
					this.on_pick(value)

					return
				}
			}

			this.current_date = null
			this.$emit("input", null)
		},

		on_pick(new_value)
		{
			const printable_new_value = api.format_date(api.date_to_iso(new_value))

			this.current_date = printable_new_value
			this.current_date_pick = new_value
			new_value = api.date_to_iso(new_value)
			this.$emit("input", new_value)
		},
	}
}

</script>

<style scoped>
.data-picker
{
	position: relative;
}

.data-picker_datepicker
{
	position: absolute;
	right: .5rem;
	top: 50%;
	bottom: 50%;
	transform: translateY(-50%);
	z-index: 1;
	width: 1.25rem;
	height: 1.25rem;
}

.data-picker_datepicker >>> .dropdown-toggle
{
	mask-image: url("~@/assets/icons/calendar_today.svg");
	mask-size: cover;
	background-color: var(--bft-neutral-400);
}

.data-picker_datepicker >>> .dropdown-toggle svg
{
	display: none;
}
</style>

